import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
let resError = ''

export const getResultImpactType = async ({ company_id, token }) => {
  let url = ''
  if (company_id !== 0) {
    url = `impacttype?company_id=${company_id}&limit=99`
  } else {
    url = `impacttype?limit=99`
  }
  try {
    return await clientPublic
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultImpactTypeV2 = async ({ company_id, token }) => {
  let url = ''
  if (company_id !== 0) {
    url = `/core/management/impacttype?company_id=${company_id}`
  } else {
    url = `impacttype?limit=99`
  }
  try {
    return await clientPublicService
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getImpactTypeById = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(`impacttype/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const addImpactType = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('impacttype', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateImpactType = async ({ params, token }) => {
  try {
    return await clientPublic
      .put(`impacttype/${params.id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deleteImpactType = async ({ id, code, token }) => {
  try {
    return await clientPublicService
      .delete(`/core/impacttype/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeImpacttype = async ({ token }) => {
  try {
    return await clientPublic
      .get(`impacttype/tree?lang=en`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeImpacttypeV2 = async ({ token }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/impacttype/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getCheckUsedImpacttype = async ({ id, code, token }) => {
  try {
    return await clientPublic
      .get(`impacttype/used/${id}?code=${code}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getDataCompanyV2 = async ({ token, level, level_id }) => {
  try {
    return await clientPublicService

      .get(`/core/management/company/dropdown`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
